import Vue from 'vue'
import Router from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/Home.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/database',
      name: 'Database',
      component: () => import('./views/Database.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: () => import('./views/Analytics.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/About.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/accessdenied',
      name: 'AccessDenied',
      component: () => import('./views/AccessDenied.vue'),
    },
    {
      path: '/oidc-callback',
      name: 'oidcCallback',
      component: () => import('./views/OidcCallback.vue'),
      meta: {
        isOidcCallback: true,
        isPublic: true
      }
    }
  ]
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store))

export default router;